import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, onyxLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  number: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  caption: {
    marginTop: 4,
  },
  delta: {
    marginTop: 2,
  },
  base: {
    backgroundColor: alabaster,
  },
  text: {
    color: onyxLight,
  },
  metricsContainer: {
    paddingRight: indent / 4,
    alignItems: 'flex-end',
  },
  suffixContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  arrowIcon: {
    color: onyxLight, // Updated to onyxLight for better contrast
  },
});
